<template>
  <div class="d-flex flex-column align-center">
    <v-progress-circular
      :rotate="-90"
      :size="104"
      :width="8"
      :value="trustPercent"
      :color="canTrust ? 'success' : 'rating'"
      class="patient-profile-modal__progress-circular mb-4"
    >
      <div class="text-h5 text--text">
        {{ trustPercent }}%
      </div>
    </v-progress-circular>
    <span
      v-if="canTrust"
      class="text-body-2 px-2 py-1 rounded-lg bg-success success--text"
    >
      {{ t('Можно доверять', options) }}
    </span>
    <span
      v-else
      class="text-body-2 px-2 py-1 rounded-lg bg-warning warning--text"
    >
      {{ t('Доверяйте с осторожностью', options) }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import getUserLanguage from 'src/utils/getUserLanguage'
import I18NextVue from 'i18next'

defineProps<{
  trustPercent: number
  canTrust: boolean
}>()

const options = { ns: getUserLanguage() }
const { t } = I18NextVue
</script>
